import { createAdminWrittenAccountPreviews } from "./AdminWrittenAccountPreviews";

export const AdminWrittenAccountPreviewsAll = createAdminWrittenAccountPreviews(
	"admin_written_accounts",
	(account) => account.hasBeenActive,
);
